import BasicPie from './BasicPie.json';
import DataLabelsPie from './DataLabelsPie.json';
import LegendOnlyPie from './LegendOnlyPie.json';
import LegendDataLabelsPie from './LegendDataLabelsPie.json';

export default [BasicPie, DataLabelsPie, LegendOnlyPie, LegendDataLabelsPie];
